import { TResourceTypeChange, TUserItem, TUserSelfInvitationItem } from '@/data/types';

export interface SocketsState {
  isConnected: boolean;

  socketId?: string;
  resourceType: TResourceTypeChange[] | null;
}

export const DefaultSocketsState: SocketsState = {
  isConnected: false,
  resourceType: null,
};
